import {
    MatchingTransactionsResponseSchema,
    ruleContract,
} from "@common/contracts/rule.contract";
import { transactionListItemSchema } from "@common/schemas/transaction.schema";
import z from "zod";
import { getBackendAPIClient } from "./backendAPIClient";

const ruleContractClient = getBackendAPIClient(ruleContract);

const AppliedTransactionsResponseSchema = z.object({
    transactions: z.array(transactionListItemSchema),
    total: z.number(),
});

type GetRulesMatchingTransactionsDto = z.infer<
    typeof ruleContract.getMatchingTransactions.body
>;

export async function getMatchingTransactionsForRule(
    workspaceId: string,
    data: GetRulesMatchingTransactionsDto,
) {
    const response = await ruleContractClient.getMatchingTransactions({
        params: { workspaceId },
        body: data,
    });

    return MatchingTransactionsResponseSchema.parse(response.body);
}

export async function getAppliedTransactionsForRule(
    workspaceId: string,
    ruleId: string,
    data: { page: number; limit: number },
) {
    const response = await ruleContractClient.getAppliedTransactions({
        params: { workspaceId, ruleId },
        body: data,
    });

    return AppliedTransactionsResponseSchema.parse(response.body);
}
